(() => {
  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR',
  });
  const money = (cents) => window.CloudlessMoney?.format(cents) ?? moneyFormatter.format((Number(cents) || 0) / 100);

  const parseCents = (text) => {
    const digits = (text || '').replace(/[^\d]/g, '');
    return digits ? Number(digits) : 0;
  };

  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  const setHidden = (element, hidden) => {
    if (element && element.hidden !== hidden) element.hidden = hidden;
  };

  function syncWithKaching(root) {
    const bundle = root.querySelector('.kaching-bundles__block');
    if (!bundle) return;

    const selectedBar = bundle.querySelector('.kaching-bundles__bar--selected');
    const subscriptionCheckbox = bundle.querySelector('.kaching-bundles__subscriptions [role="checkbox"]');
    const subscribed = subscriptionCheckbox?.getAttribute('aria-checked') === 'true';
    const price = parseCents(selectedBar?.querySelector('.kaching-bundles__bar-price')?.textContent);
    const comparePrice = parseCents(selectedBar?.querySelector('.kaching-bundles__bar-full-price')?.textContent);

    if (price) {
      root.querySelectorAll('[data-clp-atc-price]').forEach((element) => setText(element, money(price)));
      root.querySelectorAll('[data-clp-klarna-amount]').forEach((element) => setText(element, money(Math.ceil(price / 3))));
    }
    root.querySelectorAll('[data-clp-atc-compare]').forEach((element) => {
      const showCompare = comparePrice > price;
      setText(element, showCompare ? money(comparePrice) : '');
      setHidden(element, !showCompare);
      element.style.display = showCompare ? '' : 'none';
    });
    root.querySelectorAll('[data-clp-klarna-focus]').forEach((element) => setHidden(element, subscribed));
    root.querySelectorAll('[data-clp-klarna-hide]').forEach((element) => setHidden(element, !subscribed));
  }

  function initKachingBuyBox(root) {
    if (root.dataset.kachingInitialized === 'true') return;
    root.dataset.kachingInitialized = 'true';

    let frame = 0;
    const schedule = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        syncWithKaching(root);
      });
    };

    new MutationObserver(schedule).observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'aria-checked'],
    });
    root.addEventListener('click', () => setTimeout(schedule, 50));
    schedule();
    // Kaching writes its own price (in the shop's money format) into the button after it renders; sync again after that
    window.addEventListener('load', () => [0, 600, 1500, 3000].forEach((delay) => setTimeout(schedule, delay)), { once: true });
  }

  const init = () => document.querySelectorAll('[data-clp-product-main][data-clp-kaching]').forEach(initKachingBuyBox);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
